import AttendenceReportsContainer from "../../container/admin/attendence-reports";

const AttendenceReportsView = () => {
    return <AttendenceReportsContainer />;
};

export default AttendenceReportsView;